import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="home" className="relative w-full min-h-[100vh] flex items-center justify-center overflow-hidden" style={{
    backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/rrdRahQt5scik4eY2F61os/slater-elite-hero.png")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed'
  }} data-id="element-133">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/65 z-0" data-id="element-134"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center pt-20 pb-12" data-id="element-135">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-heading font-black text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl uppercase tracking-tight leading-tight mb-6 max-w-5xl" data-id="element-136">
          TRAIN ELITE. COMPETE ELITE. BE ELITE.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-gray-200 text-lg md:text-xl lg:text-2xl max-w-3xl mb-10 font-medium" data-id="element-137">
          Sports performance training for athletes of all ages and skill levels
          — Maricopa & East Valley, AZ
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-16" data-id="element-138">
          <a href="#contact" className="w-full sm:w-auto bg-sep-red hover:bg-sep-red-dark text-white font-bold py-4 px-8 rounded-md text-center transition-colors min-w-[200px] flex items-center justify-center" data-id="element-139">
            Book Your Elite Session
          </a>
          <a href="#programs" className="w-full sm:w-auto bg-transparent border-2 border-white text-white hover:bg-white hover:text-sep-black font-bold py-4 px-8 rounded-md text-center transition-colors min-w-[200px] flex items-center justify-center" data-id="element-140">
            View Programs
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="mt-auto pt-10 border-t border-white/20 w-full max-w-3xl" data-id="element-141">
          <p className="text-gray-300 text-sm md:text-base font-medium tracking-widest uppercase flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-142">
            <span data-id="element-143">NASM Certified</span>
            <span className="hidden sm:inline text-sep-red" data-id="element-144">•</span>
            <span data-id="element-145">ESA-Approved Vendor</span>
            <span className="hidden sm:inline text-sep-red" data-id="element-146">•</span>
            <span data-id="element-147">ASU Sports Science</span>
          </p>
        </motion.div>
      </div>
    </section>;
}